export default __webpack_public_path__ + "static/media/handbook-icon.6dc5ca80.svg";